<template>
  <Suspense>
    <component :is="routeComponent" />
    <template #fallback>
      <div class="loading">Loading...</div>
    </template>
  </Suspense>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'

const props = defineProps({
  route: {
    type: String,
    required: true
  }
})

// Map routes to their components
const routeComponents = {
  '/': defineAsyncComponent(() => import('../HomePage.vue')),
  '/about': defineAsyncComponent(() => import('../About.vue')),
  '/contact': defineAsyncComponent(() => import('../Contact.vue')),
  '/news': defineAsyncComponent(() => import('../NewsListing.vue'))
}

// Computed to get the correct component for the route
const routeComponent = computed(() => {
  // Handle dynamic routes like /news/:docId
  if (props.route.startsWith('/news/') && props.route !== '/news') {
    return defineAsyncComponent(() => import('../NewsSingle.vue'))
  }
  
  // Return the component for the route, or HomePage as fallback
  return routeComponents[props.route] || routeComponents['/']
})
</script>

<style scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  font-size: 1.5rem;
  color: var(--theme-accent);
}
</style> 